import React, { useState } from "react";
import { AppProvider, useApp } from "./context/AppContext";
import IntroScreen from "./components/IntroScreen";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import Transactions from "./pages/Transactions";
import Insights from "./pages/Insights";

import "./App.css";

function AppLayout() {
  const { state } = useApp();
  const { theme, activePage } = state;
  const dark = theme === "dark";
  const [showIntro, setShowIntro] = useState(true);
  const [mobileMenu, setMobileMenu] = useState(false);

  if (showIntro) return <IntroScreen onComplete={() => setShowIntro(false)} />;

  const pages = { dashboard: <Dashboard />, transactions: <Transactions />, insights: <Insights /> };

  return (
    <div style={{
      display: "flex", minHeight: "100vh",
      background: dark ? "#070d1a" : "#f1f5f9",
      fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif",
      color: dark ? "#e2e8f0" : "#0f172a",
    }}>
      {/* Sidebar */}
      <div className={`sidebar-wrapper ${mobileMenu ? "open" : ""}`}>
        <Sidebar mobileOpen={mobileMenu} onClose={() => setMobileMenu(false)} />
      </div>

      {/* Mobile overlay */}
      {mobileMenu && (
        <div onClick={() => setMobileMenu(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 40, display: "none" }} className="overlay-mobile" />
      )}

      {/* Main content */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0, overflowX: "hidden" }}>
        <Header onMenuToggle={() => setMobileMenu(!mobileMenu)} />
        <main style={{ flex: 1, overflowY: "auto" }}>
          {pages[activePage] || <Dashboard />}
        </main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppLayout />
    </AppProvider>
  );
}
